<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <b-row style="max-width: 100%" class="padding-ten-tb">
      <b-col cols="12">
        <h5 class="color-gray">{{ pageTitle }}</h5>
      </b-col>
    </b-row>

    <GestorCentralizadoTab />
  </div>
</template>

<script>
import GestorCentralizadoTab from "@/components/GestorCentralizado/GestorCentralizadoTab.vue";
import { MESSAGES } from "@/services/gestor-centralizado/gestor-centralizado.constants";
import { isProveedor } from "@/constants/perfiles";
import { mapState } from "vuex";

import "@/styles/gestor-centralizado/gestor-centralizado.css";

export default {
  name: "LiquidacionesGestorCentralizadoView",

  components: {
    GestorCentralizadoTab,
  },

  computed: {
    ...mapState("module", ["perfil"]),
    pageTitle() {
      return MESSAGES.TAB_GESTOR_CENTRALIZADO;
    },
  },

  mounted() {
    if (isProveedor(this.perfil)) {
      this.$router.replace({ name: "BlockedPage" });
    }
  },
};
</script>
